<template>
  <el-cascader ref="cascader" v-model="value" :options="options" :props="props" @change="change" :placeholder="placeholder" :style="css" :key="isResourceShow" clearable>
  </el-cascader>
</template>

<script>
import { getCategoryList } from "@/api/category";
export default {
  name: "CategoryCas",
  props: {
    css: {
      type: Object,
      default: () => {
        return { width: "85%" };
      }
    },
    props: {
      type: Object,
      default: () => {
        return { expandTrigger: "hover" };
      }
    },
    deep: {
      type: Number,
      default: 0
    },
    fArray: {
      type: Array,
      default: () => {
        return [];
      }
    },
    placeholder: {
      type: String,
      default: "请选择商品分类"
    },
    defaultValue:{
      type: String,
      default: ""
    },
  },
  data() {
    return {
      value: "",
      options: [],
      currentValue: "",
      isResourceShow: 0
    };
  },
  watch:{
    'defaultValue':{
      immediate:true,  //立即执行
      handler:function(newVal){
        this.value = newVal;
      }
    }



  },
  methods: {
    // 获取分类
    getCategory(params) {
      console.log(params);
      getCategoryList({ ...params }).then(d => {
        let data = d.data;
        data.forEach(item => {
          item.value = item.id;
          item.label = item.name;
        });
        ++this.isResourceShow;
        this.options = this.formatTree(data, this.fArray, this.deep);
      });
    },
    change(value) {
      this.$emit("getCategory", value);
    },
    reset() {
      this.value = "";
      this.currentValue = "";
      ++this.isResourceShow;
      this.options = [];
      this.$refs.cascader.handleClear();
    },
    changeVal(id, name) {
      this.$emit("getCategory", id);
      this.currentValue = name;
    }
  }
};
</script>





// WEBPACK FOOTER //
// src/components/CategorySelect/index.vue